import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { inject } from '@angular/core';
import { InAppNotificationsService } from './in-app-notifications.service';

export interface InAppNotifications {
  inAppNotifications: any | null;
  loading: boolean;
}

export const inAppNotificationsInitialState: InAppNotifications = {
  inAppNotifications: null,
  loading: false,
};

export const InAppNotificationsStore = signalStore(
  { providedIn: 'root' },
  withState(inAppNotificationsInitialState),
  withMethods((store) => {
    return {
      resetStore() {
        patchState(store, inAppNotificationsInitialState);
      },
    };
  })
);